module.exports = __webpack_public_path__ + "img/default-retail-product-muted.6f21adca.png";